module.exports = __webpack_public_path__ + "img/Weapon_97.b95e3e33.png";